var map = {
	"./Amex.svg": "c6eb",
	"./Cabal.svg": "06a5",
	"./Elo.svg": "a948",
	"./Hipercard.svg": "080d",
	"./Mastercard.svg": "ef72",
	"./Visa.svg": "fef7",
	"./add_photo.svg": "4eb0",
	"./boleto.svg": "0a4f",
	"./copSolid.svg": "01b5",
	"./fotoDefault.svg": "b311",
	"./icons/dash-icon.svg": "6ab7",
	"./icons/favicon.svg": "324c",
	"./icons/installers.svg": "636f",
	"./imp.svg": "1034",
	"./logo-imprimax-mini.svg": "179e",
	"./logo-imprimax.svg": "f8aa",
	"./logo-imprimax2.svg": "8c15",
	"./pix-icon.svg": "7253",
	"./plus.svg": "8a37",
	"./tela-login-mobile.svg": "ad02",
	"./tela-login.svg": "e779",
	"./vuetify.svg": "6dff"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";